import { useCallback } from 'react';
import { MESSAGE_FIELD_ID, SDK } from 'sdk';

import { useUIState } from '../../../../app/App';
import { useMessageField } from '../../fields/messageField/common';
import { useCachedMessageField } from '../../fields/messageField/hooks/useCachedMessageField';
import { useSDK } from './../../../../app/App';

type ReturnType = {
	setMessage: (s: string) => void;
	onSendClick: VoidFunction;
	onSuggestionSelect: (s: string) => void;
	message: string;
};

export const useForm = (rootStore: SDK): ReturnType => {
	const [message, setMessage, resetMessage] = useMessageField(rootStore.formsStore.getCachedValue(MESSAGE_FIELD_ID));
	const { attachmentErrorsStore, scrollStore } = useUIState();
	const { attachmentsStore } = useSDK();
	useCachedMessageField(MESSAGE_FIELD_ID, message);
	const repliedMessage = rootStore.replyMessageStore.repliedMessage;
	const sendMessage = useCallback(
		async (text: string) => {
			const existingConversationIsLast = await rootStore.existingConversationIsLast();
			if (existingConversationIsLast) {
				if (rootStore.conversationsStore.isLatestConversationResolved) {
					await rootStore.startNewConversation(
						{ text, replyToId: typeof repliedMessage === 'object' ? repliedMessage?.id : undefined },
						{},
						true
					);
					rootStore.formsStore.setCachedValue(MESSAGE_FIELD_ID, '');
				} else if (typeof repliedMessage === 'object') {
					rootStore.sendMessage({ text, replyToId: repliedMessage?.id });
				} else {
					rootStore.sendMessage({ text });
				}
				resetMessage();
			} else {
				//Если текущий диалог отличается от последнего, то это значит, что диалог уже начали на другом устройстве.
				//Поэтому нужно обновить текущий диалог, но сообщение в таком случае не отправляем
				await rootStore.updateConversation();
			}
			rootStore.replyMessageStore.clearRepliedMessage();
		},
		[rootStore, repliedMessage, resetMessage]
	);
	const onSendClick = useCallback(() => {
		if (message || !!attachmentsStore.unsentAttachments.size) {
			sendMessage(message);
			attachmentErrorsStore.clearError();
			scrollStore.scrollToBottom();
		}
	}, [message, sendMessage, attachmentErrorsStore, scrollStore, attachmentsStore]);

	const onSuggestionSelect = useCallback(
		(text: string) => {
			sendMessage(text);
		},
		[sendMessage]
	);

	return { setMessage, onSendClick, onSuggestionSelect, message };
};
